import { useEffect } from 'react';
import { doTagSessionExpiredModalPage } from 'components/sessionTimeOut/tagging';

export const useRecordPage = ({ showModal, userProfile, productsDescription, setPageName }) => {
    useEffect(() => {
        if (showModal) {
            setPageName(doTagSessionExpiredModalPage(userProfile, productsDescription));
        }
    }, [showModal]);
};
